import { List, LottiePlayer, MainTitle, Svg } from '@repo/ui';

export const BznavRefundGoodPoint = () => {
  const goodPointsData = [
    {
      overline: '5년간 공제·감면을 받지 못해 생긴',
      title: '더 낸 세금을 정당하게 돌려받으세요',
      iconSrc: 'icg_moneybag_md.svg'
    },
    {
      overline: '국세청이 권장하는 제도',
      title: '경정청구는 세무조사와 무관해요',
      iconSrc: 'icg_shield_sm.svg'
    },
    {
      overline: '안정적으로 환급받을 수 있도록',
      title: '환급에 특화된 세무 전문가가 검토해요',
      iconSrc: 'icg_aim_md.svg'
    },
    {
      overline: '부담 없이 신청할 수 있는 이유',
      title: '환급 실패하면 이용료 0원이에요',
      iconSrc: 'icg_heart-hand_md.svg'
    },
    {
      overline: '100% 책임환불제로',
      title: '불이익 발생하면 이용료를 돌려드려요',
      iconSrc: 'icg_bankbook-arrow-left_md.svg'
    }
  ];

  return (
    <section className={'py-normal-medium bg-white'}>
      <div className={'max-w-[520px] mx-auto page-padding'}>
        <MainTitle title={'안심하고 꼭 돌려받으세요'} size={'small'} />
        {goodPointsData.map((item, index) => (
          <List
            key={index}
            size={'medium'}
            className={'p-normal-small'}
            overline={item.overline}
            title={item.title}
            leadingElement={
              item.iconSrc === 'NaverIcon' ? (
                <LottiePlayer src={'/lotties/partners-lottie.json'} className={'w-[32px] h-[32px]'} />
              ) : (
                <Svg src={item.iconSrc} width={32} height={32} />
              )
            }
          />
        ))}
      </div>
    </section>
  );
};
